import React from 'react'
import { NumberHandler } from 'utils'


const PlanInput = ({ idx, item, planChangeHandler }) => (
    <fieldset className="fieldset-quantity d-block">
        <section className="radio">
            <label className="ua-radio ua-input">
                <input
                    type="radio"
                    name="quantity"
                    className={`radio-quantity-${item.expiration} radio-quantity`}
                    defaultChecked={!idx}
                    data-plan={item.id}
                    onChange={planChangeHandler}
                />

                <i className="ua-radio-icon"/>

                <span className="txt-red txt-normal">
                    {(item.price === 0)
                        ?
                        'FREE'
                        :
                        `$${NumberHandler.comma(item.price)}`}
                </span>

                <small className="txt-dark-grey">
                    {` / ${(item.expiration === 0)
                        ?
                        '無期限'
                        :
                        (item.expiration === 6)
                            ?
                            '半'
                            :
                            (item.expiration % 12 === 0) ? item.expiration / 12 : item.expiration}
                        ${(item.expiration === 0)
                            ?
                            ''
                            :
                            (item.expiration === 6 || item.expiration % 12 === 0) ? '年' : '個月'}`}
                </small>
            </label>
        </section>
    </fieldset>
)


export default PlanInput
